import React from 'react';
import Handlebars from 'handlebars';
import { useReseller } from 'hooks/Reseller/useReseller';
import { useDCSText } from 'hooks/useDCSText';

/**
 * A component that processes a single text node using useDCSText
 * and compiles it with Handlebars templates.
 *
 * @param {Object} props - The props object.
 * @param {string} props.text - The text to process.
 * @returns {React.ReactElement} The processed text.
 */
export const TextProcessor: React.FC<{ text: string }> = ({ text }) => {
  const { resellerTemplate } = useReseller();
  const dcsText = useDCSText(text);
  const templateData = { shop: resellerTemplate };

  try {
    const template = Handlebars.compile(dcsText);
    return <>{template(templateData)}</>;
  } catch (error) {
    console.error(error);
    return <>{text}</>;
  }
};
